var map = {
	"./404.png": [
		94710,
		94710
	],
	"./500.png": [
		59865,
		59865
	],
	"./activities-empty-state.png": [
		92658,
		92658
	],
	"./goals-coming-soon.png": [
		68306,
		68306
	],
	"./goals-empty-state.png": [
		56045,
		56045
	],
	"./kum.png": [
		90296,
		90296
	],
	"./liliya.png": [
		12961,
		12961
	],
	"./meetings-empty-state.png": [
		34998,
		34998
	],
	"./meetings-info.png": [
		12114,
		12114
	],
	"./notifications-empty-state.png": [
		83227,
		83227
	],
	"./people-empty-state.png": [
		60029,
		60029
	],
	"./projects-empty-state.png": [
		94776,
		94776
	],
	"./projects/pattern-1.png": [
		58689,
		63904
	],
	"./projects/pattern-2.png": [
		51396,
		51396
	],
	"./projects/pattern-3.png": [
		80717,
		80717
	],
	"./projects/pattern-4.png": [
		6635,
		6635
	],
	"./projects/pattern-5.png": [
		5188,
		5188
	],
	"./resources-empty-state.png": [
		75257,
		75257
	],
	"./teams-empty-state.png": [
		70546,
		70546
	],
	"./updates-empty-state.png": [
		17897,
		17897
	],
	"./updates-info.png": [
		79141,
		79141
	],
	"./workflows-empty-state.png": [
		37969,
		37969
	],
	"./workflows-info.png": [
		25883,
		30479
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 59976;
module.exports = webpackAsyncContext;